import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useCommunicationWorkflows } from "../../hooks"; // Your existing hook
import { Loader2 } from "lucide-react";
import { Details } from "./details";
import { usePageViewTimer } from "@shared/hooks/usePageViewTimer";

export const WorkflowViewPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const { data, isLoading, error } = useCommunicationWorkflows({
    page: 1,
    limit: 100, // Large enough to find the workflow
  });

  const workflow = data?.results?.find((w) => w.id.toString() === id);
  usePageViewTimer({pageName: `WorkFlow Detail of ${id}`})
  const handleSave = (updatedWorkflow: any) => {};

  const handleCancel = () => {
    navigate("/communication-hub/workflows");
  };

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <Loader2 className="h-8 w-8 animate-spin" />
      </div>
    );
  }

  if (error || !workflow) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <div className="text-center">
          <h3 className="text-lg font-semibold text-gray-900">
            Workflow not found
          </h3>
          <p className="text-gray-600 mt-2">
            {error
              ? "Error loading workflow."
              : "The workflow you're looking for doesn't exist."}
          </p>
          <button
            onClick={handleCancel}
            className="mt-4 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            Back to Workflows
          </button>
        </div>
      </div>
    );
  }

  return (
    <Details
      workflow={workflow}
      onSave={handleSave}
      onCancel={handleCancel}
      mode="view" // This makes it read-only
    />
  );
};
